import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=10de67fd&scoped=true"
import script from "./WorkDetail.vue?vue&type=script&lang=js"
export * from "./WorkDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&id=10de67fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de67fd",
  null
  
)

export default component.exports